interface InboxColumn {
  key: string;
  label: string;
  className?: string;
}

interface InboxTableProps {
  columns: InboxColumn[];
  emptyMessage: string;
  hasRows: boolean;
  children: React.ReactNode;
}

export function InboxTable({
  columns,
  emptyMessage,
  hasRows,
  children,
}: InboxTableProps) {
  return (
    <div className={ `px-4 pb-4 overflow-x-auto` }>
      <table className={ `min-w-full divide-y divide-gray-200` }>
        <thead className={ `bg-gray-50` }>
          <tr>
            { columns.map(column => (
              <th
                key={ column.key }
                className={ `px-3 py-2 text-left text-xs font-semibold text-gray-600 uppercase tracking-wide ${column.className || ``}` }
              >
                { column.label }
              </th>
            )) }
          </tr>
        </thead>
        <tbody className={ `bg-white divide-y divide-gray-100` }>
          { children }
          { !hasRows ? (
            <tr>
              <td
                colSpan={ columns.length }
                className={ `px-3 py-6 text-center text-sm text-gray-500` }
              >
                { emptyMessage }
              </td>
            </tr>
          ) : null }
        </tbody>
      </table>
    </div>
  );
}
